import React from "react";
import styles from "../../../../assets/styles/components/Suggestion.module.scss";

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------
export type DeviceType = "DESKTOP" | "MOBILE" | "TABLET" | "CONNECTED_TV";

export type GoogleDeviceTargeting = {
  device_type: DeviceType;
  device_label: string;
  before_bid_modifier: number | null; // -1.0: OFF, 0/null: ON
  suggested_bid_modifier: number | null;
  reason?: string;
};

type Props = {
  devices: GoogleDeviceTargeting[];
  formData: Record<DeviceType, number | null>;
  onChange: (type: DeviceType, val: number | null) => void;
};

// -----------------------------------------------------------------------------
// Component: TargetingDeviceForm
// -----------------------------------------------------------------------------
const TargetingDeviceForm: React.FC<Props> = ({ devices, formData, onChange }) => {
  return (
    <div className={styles.targetingDeviceFormContainer}>
      {devices.map((device) => {
        const beforeValue = device.before_bid_modifier === -1.0 ? -1.0 : 0.0;
        const isBeforeEnabled = beforeValue !== -1.0;
        const currentModifier = formData[device.device_type];
        const afterValue = currentModifier === -1.0 ? -1.0 : 0.0;
        const isAfterEnabled = afterValue !== -1.0;

        return (
          <section key={device.device_type} className={styles.campaignCard}>
            <div className={styles.campaignName}>{device.device_label}</div>

            {device.reason && (
              <div className={styles.reasonBar}>
                <strong>Aibex提案理由:</strong> {device.reason}
              </div>
            )}

            <div className={styles.suggestionBox}>
              {/* Before */}
              <div className={styles.beforePanel}>
                <div className={styles.panelTitle}>現在の設定</div>
                <div className={styles.displayRow}>
                  <div className={`${styles.statusBadge} ${isBeforeEnabled ? styles.bgOn : styles.bgOff}`}>
                    {isBeforeEnabled ? "配信 ON" : "配信 OFF"}
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className={styles.arrowIcon}>→</div>

              {/* After */}
              <div className={styles.afterPanel}>
                <div className={styles.panelTitle}>AI提案</div>
                <div className={styles.inputRow}>
                  <label className={styles.checkboxSwitch}>
                    <input
                      type="checkbox"
                      checked={isAfterEnabled}
                      onChange={(e) => onChange(device.device_type, e.target.checked ? 0.0 : -1.0)}
                    />
                    <span className={styles.slider}></span>
                  </label>
                  <div className={`${styles.statusBadge} ${isAfterEnabled ? styles.bgOn : styles.bgOff}`}>
                    {isAfterEnabled ? "配信 ON" : "配信 OFF"}
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default TargetingDeviceForm;
